module.exports = __webpack_public_path__ + "img/cargo_stopped.8f56f3ee.svg";